import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../store'
import {User} from "../api/Models";
import {PURGE} from "redux-persist/es/constants";

export interface AuthState {
  user: User|null
  jwtToken: string|null
}

// Define the initial state using that type
const initialState: AuthState = {
  user: null,
  jwtToken: null
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState
    })
  },
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload
    },
    setJwtToken: (state, action: PayloadAction<string>) => {
      state.jwtToken = action.payload
    },
  }
})

export const { setUser, setJwtToken } = authSlice.actions

// Other code such as selectors can use the imported `RootState` type
export const selectUser = (state: RootState) => state.auth.user
export const selectJwtToken = (state: RootState) => state.auth.jwtToken

export default authSlice.reducer